<div class="picker" fxLayout fxLayoutAlign="space-between">
    <input #pickerInput
        fxFlex="auto"
        disabled="true"
        (colorPickerClose)="close()"
        [style.background]="color"
        [cpOutputFormat]="'rgba'"
        [cpPosition]="'bottom'"
        [cpCancelButton]="true"
        [cpCancelButtonClass]="'mat-raised-button btn'"
        [(colorPicker)]="color"
        [cpIgnoredElements]="[pickerInput, pickerButton]"
        [(cpToggle)]="toggle"
        [cpAlphaChannel]="alphaChannel ? 'always' : 'disabled'" />
    <mat-icon
        fxFlex="nogrow"
        #pickerButton class="icon"
        (click)="toggle = disabled ? false : !toggle"
        [matTooltip]="!disabled ? 'changeColor' : 'color' | translate"
        [style.color]="color" svgIcon="palette">
    </mat-icon>
</div>